import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import SpørgIkke from "./pages/SpørgIkke";
import Foredrag from "./pages/Foredrag";
import JegTilbyder from "./pages/JegTilbyder";
import Om from "./pages/Om";
import Kontakt from "./pages/Kontakt";
import Privatlivspolitik from "./pages/Privatlivspolitik";
import Handelsbetingelser from "./pages/Handelsbetingelser";

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="spoerg-ikke" element={<SpørgIkke />} />
          <Route path="foredrag" element={<Foredrag />} />
          <Route path="jeg-tilbyder" element={<JegTilbyder />} />
          <Route path="om" element={<Om />} />
          <Route path="kontakt" element={<Kontakt />} />
          <Route path="privatlivspolitik" element={<Privatlivspolitik />} />
          <Route path="handelsbetingelser" element={<Handelsbetingelser />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}

export default App;
